import { useObserver, useSubtree } from "subtree.js/react";
import { BackButton, OnboardingLayout, PrimaryButton } from "../../components/onboarding/OnboardingLayout";
import { VendorShowsSection } from "../events/sections/vendor-shows/vendor-shows-section";
import { type BookedTable, OnboardingShowActions, OnboardingShowState } from "./onboarding-show-model";

function TableBooked({ table }: { table: BookedTable | null }) {
  return (
    <div className="flex items-start gap-3 rounded-row border border-accent px-3.5 py-3">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent text-[13px] font-semibold text-ink">
        ✓
      </span>
      {table ? (
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-medium text-white">
            Table {table.label} · {table.show}
          </p>
          <p className="text-xs leading-snug text-muted">{table.when}</p>
          <p className="text-xs leading-snug text-muted">{table.where}</p>
        </div>
      ) : (
        <p className="text-[13px] font-medium text-white">Your table is booked.</p>
      )}
    </div>
  );
}

export function OnboardingShowPage() {
  const state = useSubtree(OnboardingShowState);
  const actions = useSubtree(OnboardingShowActions);
  const observer = useObserver();
  const storeId = observer.watch(state.storeId) ?? undefined;
  const hasBooth = observer.watch(state.hasBooth);
  const table = observer.watch(state.table);
  const booking = observer.watch(state.booking);

  return (
    <OnboardingLayout
      step="show"
      title={hasBooth ? "You have a table" : "Your table at the show"}
      description={
        hasBooth
          ? "It's on your account. On the show's days, this is where you take card payments."
          : "We emailed you a code when you booked. Enter it here to add the table to your account."
      }
      storeId={storeId}
      footer={
        <div className="flex items-center justify-between gap-3">
          <BackButton onClick={actions.back} />
          <PrimaryButton type="button" onClick={actions.next} disabled={!hasBooth}>
            Continue
          </PrimaryButton>
        </div>
      }
    >
      {hasBooth ? (
        <TableBooked table={table} />
      ) : (
        <>
          <VendorShowsSection listShows={booking} codeLabel="Code from your booking email" />
          {!booking && (
            <button
              type="button"
              onClick={actions.startBooking}
              className="mt-3 w-full rounded-row border border-line px-3.5 py-3 text-left transition-colors hover:border-accent"
            >
              <p className="text-[13px] font-medium text-white">I don't have a code</p>
              <p className="mt-0.5 text-xs leading-snug text-muted">Book a table at an upcoming show.</p>
            </button>
          )}
        </>
      )}
    </OnboardingLayout>
  );
}
